import React from "react";
import './c31_agevolazioni_economiche.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";

class AgevolazioniEconomiche extends TemplateComponent {

    componentRender(data) {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        };

        return (
            <div id={!isMobileOnly ? 'agevolazioni-economiche' : 'agevolazioni-economiche-mob'}>
                <div className="container-fluid">
                    <div className="row">
                            <div className="col-12 agevolazioni-economiche-container">
                                <div className="shadow-prev"></div>
                                <div className="shadow-next"></div>
                                <Slider {...settings}>
                                    {data.cards.map((card, index) => (
                                        <div key={index}>
                                            <div className="agevolazioni-economiche-title">{card.title}</div>
                                            <div className="agevolazioni-economiche-subtitle">
                                            <span  {...insertHtml(card.text)} />
                                                {card.cta ? <span className="agevolazioni-economiche-cta"><a href={card.url}>{card.cta}</a></span> : null}
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                </div>
            </div>
        )
    }
}

export default AgevolazioniEconomiche;
